import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import elSelectCityChose from "@/components/elSelectCityChose/elSelectCityChose.vue";
export default {
  components: {
    elSelectCityChose: elSelectCityChose
  },
  props: {
    showCreate: {
      type: Boolean,
      default: true
    },
    childData: {
      type: Object,
      default: null
    }
  },
  computed: {
    //判断传过来的数据是否为真，用作新增或者编辑
    childLen: function childLen() {
      return this.childData.length;
    }
  },
  watch: {
    // 监听弹框打开
    showCreate: {
      handler: function handler(a, b) {
        var _this = this;

        if (a) {
          // 由于address没有设置触发校验条件，因此打开弹框时默认移除地区的校验
          this.$nextTick(function () {
            _this.$refs.ruleForm.clearValidate(['address']);
          }); // 打开新增时重置表单

          if (!this.childData) {
            this.$refs.ruleForm && this.$refs.ruleForm.clearValidate();
            this.radio = 0;
            this.areaList = []; // 该账户无区域时

            if (!this.area.brcId) {
              this.$set(this.areas, 'province', '');
              this.$set(this.areas, 'city', '');
              this.$set(this.areas, 'country', '');
              this.$set(this.areas, 'brcId', '');
              this.brcId = '';
            } // 新增时设置账户类型和保函类型的默认值


            if (this.userInfo.userType == 2) {
              this.role = 0;
              this.radio = 0;
            }
          } // 有区域时，回显区域


          this.resetCity(); // 不是国瑞的时候默认设置保函类型电子

          if (this.userInfo.channel != '0000') {
            this.radio = 1;
          }
        } else {
          this.listData = null;
          this.areaList = [];
        }
      },
      immediate: true
    },
    // 监听当前编辑的数据
    childData: {
      handler: function handler(a, b) {
        if (a != null) {
          this.title = "编辑子账户";
          this.$set(this.ruleForm, 'userName', a.userName);
          this.$set(this.ruleForm, 'userPhone', a.userPhone);
          this.$set(this.ruleForm, 'pwdAgin', '');

          for (var key in a) {
            if (typeof this.ruleForm[key] != "undefined") {
              this.$set(this.ruleForm, key, a[key]);
            }
          }

          this.$set(this.ruleForm, 'realnName', a.userLoginName);

          if (this.userInfo.userType == 2) {
            this.role = Number(a["personnel"]);
            this.radio = Number(a["type"]);
          } // 获取地域名称


          this.getAreaName({
            userId: a.userId
          });
          this.listData = a;
        }
      },
      // 用immediate初始化一次防止第一次编辑无效
      immediate: true
    },
    area: function area(a, b) {
      if (a != null) {
        for (var key in a) {
          if (a[key] != '/' && a[key] != '') {
            this.$set(this.areas, key, a[key]);
          }
        }

        if (this.area.province != "不限") {
          this.brcId = this.area.brcId;
        }
      }
    }
  },
  data: function data() {
    var _this2 = this;

    var pwdAgin = function pwdAgin(rule, value, callback) {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else {
        if (value != _this2.ruleForm.userPwd) {
          callback(new Error("密码输入不一致"));
        } else {
          callback();
        }
      }
    };

    var name = function name(rule, value, callback) {
      if (value === "") {
        callback(new Error("请输入姓名"));
      } else {
        callback();
      }
    };

    return {
      areaList: [],
      pwdAginFlag: true,
      userPwdFlag: true,
      role: 0,
      danbaoRole: [{
        label: "录入员",
        value: 0
      }, {
        label: "审查员",
        value: 1
      }],
      BohanMode: [{
        label: "不限",
        value: 0
      }, {
        label: "电子保函",
        value: 1
      }, {
        label: "纸质保函",
        value: 2
      }],
      title: "新建子账户",
      listData: this.childData,
      radio: 0,
      //保函类型
      brcId: '',
      //地域编号
      areas: {
        //区域
        province: "",
        city: "",
        country: "",
        brcId: ''
      },
      ruleForm: {
        userName: "",
        //用户名
        userPwd: "",
        // 密码
        realnName: "",
        //姓名
        userPhone: "",
        //手机号
        userEmail: "",
        //邮箱
        pwdAgin: "",
        //确认密码
        address: "" //区域信息

      },
      rules: {
        pwdAgin: [{
          required: true,
          validator: pwdAgin,
          trigger: "blur"
        }],
        address: [{
          required: true,
          message: '请添加区域'
        }],
        userName: [{
          max: 16,
          message: '请输入用户名',
          required: true
        }, {
          validator: this.publicMethed.regularTest('username'),
          trigger: "blur"
        }],
        userPwd: [{
          required: true,
          validator: this.publicMethed.regularTest('password', this.childData == null ? true : false),
          trigger: "blur"
        }],
        realnName: [{
          required: true,
          validator: this.publicMethed.regularTest('fullName'),
          trigger: "blur"
        }],
        userPhone: [{
          max: 11,
          required: true,
          message: '请输入正确的手机号'
        }, {
          validator: this.publicMethed.regularTest('phoneReg'),
          trigger: "blur"
        }],
        userEmail: [{
          required: true,
          message: '请输入正确的邮箱'
        }, {
          validator: this.publicMethed.regularTest('email'),
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {
    var _this3 = this;

    // 由于address没有设置触发校验条件，会默认执行一次，此处先移除第一次检验报错
    this.$nextTick(function () {
      _this3.$refs.ruleForm.clearValidate(['address']);
    });
  },
  methods: {
    // 由于该开发用dialog未销毁组件，切换编辑新增需要手动赋值，此处做区域从area取重赋值操作
    resetCity: function resetCity() {
      if (this.area && this.area.brcId) {
        for (var key in this.area) {
          if (this.area[key] != '/' && this.area[key] != '') {
            this.$set(this.areas, key, this.area[key]);
          }
        } // 创建子账号必须限制省市区，以顶部区域为主


        if (this.area.province != "不限" && this.area.province != '') {
          this.brcId = this.area.brcId;
          this.$set(this.areas, "province", this.area.province);
        }
      }
    },
    // 根据地域编码获取地区的名称接口方法
    getAreaName: function getAreaName(data) {
      var _this4 = this;

      this.requestAPI.queryInfo(data).then(function (res) {
        _this4.areaList = [];

        var _brcId = res.data.areaCode.split(",");

        var _areaName = res.data.areaName.split("||");

        for (var i = 0; i < _areaName.length; i++) {
          var _result = _areaName[i].split(",");

          _this4.areaList.push({
            province: _result[1],
            city: _result[2] || '不限',
            country: _result[3] || '不限',
            brcId: _brcId[i]
          });
        }

        _this4.$set(_this4.ruleForm, 'address', _areaName[_areaName.length - 1]);
      });
    },
    //获取省级的回调
    provinceChange: function provinceChange(value) {
      this.brcId = '';
      this.areas.province = value.name;
      this.brcId = value.brcId;
    },
    //获取市级的回调
    cityChange: function cityChange(value) {
      this.areas.city = value.name;
      this.brcId = this.brcId.substr(0, 6) + "_" + value.brcId;
    },
    //获取区级的回调
    countryChange: function countryChange(value) {
      if (typeof value.brcId == 'undefined') {
        return;
      }

      this.areas.country = value.name;
      this.brcId = this.brcId.substr(0, 13) + "_" + value.brcId;
      this.areas.brcId = this.brcId;
    },

    /**
     * @description  选择区域后点击添加添加至区域列表
     */
    addArea: function addArea() {
      if (this.userInfo.userType != 2 && this.areaList.length > 0) {
        this.$message.error("当前只可以选择一个区域！请删除区域后重新添加!");
        return;
      }

      if (this.areas.country == '') {
        this.$message.error("请先选择区域！");
        return;
      }

      for (var i = 0; i < this.areaList.length; i++) {
        var _innerResult = this.areaList[i].brcId.split("_");

        var _otherResult = this.areas.brcId.split("_"); // if (_otherResult[0] == _innerResult[0]) {
        //     if (_innerResult[1] == '000000') {
        //         this.$message.error(`当前 `)
        //     }
        // }


        if (this.areaList[i].brcId == this.areas.brcId) {
          this.$message.error("\u5DF2\u5B58\u5728\u6216\u5DF2\u5305\u542B\u8BE5\u533A\u57DF\u7684\u4FE1\u606F ");
          return;
        }
      }

      var data = {};

      for (var key in this.areas) {
        data[key] = this.areas[key];
      }

      this.$set(this.ruleForm, 'address', this.areas.country);
      this.$refs.ruleForm.validateField(['address']); //添加成功时检验区域字段

      this.areaList.push(data);
    },

    /**
     * @description 删除已选的区域信息 
     * @param {Number} index  删除的下标 
     */
    delTemFun: function delTemFun(index) {
      this.areaList.splice(index, 1); // 如果删除了，则address清空，用于无法通过校验

      if (this.areaList.length < 1) {
        this.ruleForm.address = "";
      }
    },
    //完成按钮
    submit: function submit() {
      var _this5 = this;

      this.$refs["ruleForm"].validate(function (valid) {
        if (valid) {
          var _province = '';
          var _city = '';
          var _country = '';
          var _brcId = '';

          _this5.areaList.forEach(function (item, index) {
            // _province += ','+ item.province
            // _city += ','+ item.city
            // _country += ','+ item.country
            _brcId += ',' + item.brcId;
          });

          var data = {};
          data["brcId"] = _brcId.substring(1);
          data["personnel"] = _this5.role; // 操作员

          data["userLoginName"] = _this5.ruleForm.realnName; //姓名

          data["userName"] = _this5.ruleForm.userName, //用户名
          data["userPhone"] = _this5.ruleForm.userPhone; //手机号

          data["userEmail"] = _this5.ruleForm.userEmail; //邮箱

          data["userType"] = _this5.userInfo.userType; // 新增的时候传递加密的密码字段，编辑的时候不传密码字段

          if (_this5.listData == null) {
            data["userPwd"] = _this5.publicMethed.md5(_this5.publicMethed.md5(_this5.ruleForm.userPwd)).toUpperCase(); //密码
          }

          data["type"] = _this5.radio; //保函类型
          //如果listData是真的 说明是编辑 否则是新增

          if (_this5.ruleForm.userName == _this5.ruleForm.userPwd) {
            _this5.$message.error('用户名和密码不能重复');

            return;
          }

          if (_this5.listData != null) {
            //编辑按钮
            delete data["userName"];
            delete data["userPhone"];
            data["userId"] = _this5.listData.userId;

            _this5.requestAPI.childAccount.resetAccount(data).then(function (res) {
              _this5.$message({
                message: res.errorMsg,
                type: "success"
              });

              _this5.$nextTick(function () {
                _this5.resetForm();
              });

              _this5.$emit("addSuccess", data);
            });

            data["addType"] = 1;
          } else {
            //新增按钮
            data["parentId"] = _this5.userInfo.userId;

            _this5.requestAPI.childAccount.addAccount(data).then(function (res) {
              _this5.$message({
                message: res.errorMsg,
                type: "success"
              });

              _this5.resetForm();

              _this5.$emit("addSuccess", data);

              _this5.areas = {};
              _this5.role = 0;
            });
          }
        } else {
          return false;
        }
      });
    },
    //关闭弹框按钮
    del: function del() {
      this.resetForm();
      this.$emit("update:showCreate", false);
    },
    resetForm: function resetForm() {
      var _this6 = this;

      // 重置数据(经测试发现，重置方法重置后的值不是空，而是初始化后赋的值，因此此处只能手动重置空数据)
      setTimeout(function () {
        _this6.$set(_this6.ruleForm, 'userName', '');

        _this6.$set(_this6.ruleForm, 'userPwd', '');

        _this6.$set(_this6.ruleForm, 'realnName', '');

        _this6.$set(_this6.ruleForm, 'userPhone', '');

        _this6.$set(_this6.ruleForm, 'userEmail', '');

        _this6.$set(_this6.ruleForm, 'pwdAgin', '');

        _this6.$set(_this6.ruleForm, 'address', '');

        _this6.$refs.ruleForm.clearValidate();
      }, 200);
      this.$set(this.areas, 'province', '');
      this.$set(this.areas, 'city', '');
      this.$set(this.areas, 'country', '');
      this.$set(this.areas, 'brcId', '');
      this.brcId = '';
    }
  }
};